export const quizQuestions = [
  {
    id: "question16",
    videoId: "video16",
    topic: "TSMR",
    question: "It takes ___ to start a road rage:",
    options: ["1 person", "2 or more persons", "Neither"],
    correctAnswer: "2 or more persons",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
];
